module.exports = __webpack_public_path__ + "img/library.706ba8db.jpg";